import React, { Component } from 'react'
import { Paper, RaisedButton, TextField } from 'material-ui'

const style = {
  layout: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '24px',
    background: 'linear-gradient(135deg, #f7efe4 0%, #ffffff 60%, #eef7f2 100%)'
  },
  paper: {
    width: '100%',
    maxWidth: '720px',
    padding: '28px'
  },
  title: {
    fontSize: '28px',
    fontWeight: 600,
    marginBottom: '12px'
  },
  body: {
    fontSize: '15px',
    lineHeight: 1.7,
    color: '#314147'
  },
  success: {
    color: '#256029',
    marginTop: '16px'
  },
  error: {
    color: '#c62828',
    marginTop: '16px'
  },
  field: {
    width: '100%',
    marginTop: '16px'
  },
  button: {
    marginTop: '20px',
    marginRight: '12px'
  }
}

class ShopifyCallback extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      success: false,
      error: '',
      shop: '',
      scope: '',
      installedAt: '',
      accessToken: '',
      revealToken: false
    }
  }

  componentDidMount() {
    this.finishOauth()
  }

  finishOauth = () => {
    const params = new URLSearchParams(window.location.search)
    const payload = {}

    params.forEach((value, key) => {
      payload[key] = value
    })

    payload.appOrigin = window.location.origin

    fetch(process.env.REACT_APP_NODE_ROOT_URL + '/api/shopify/oauth/callback', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then((res) => res.json())
      .then((data) => {
        if (!data.success) {
          throw new Error(data.error || 'Unable to finish Shopify OAuth')
        }

        this.setState({
          loading: false,
          success: true,
          shop: data.shop || '',
          scope: data.scope || '',
          installedAt: data.installedAt || '',
          accessToken: data.accessToken || ''
        })
      })
      .catch((error) => {
        this.setState({
          loading: false,
          success: false,
          error: error.message || 'Unable to finish Shopify OAuth'
        })
      })
  }

  toggleToken = () => {
    this.setState({
      revealToken: !this.state.revealToken
    })
  }

  restart = () => {
    window.location.assign('/shopify/install')
  }

  renderToken() {
    if (!this.state.success || !this.state.accessToken) {
      return null
    }

    return (
      <div>
        <TextField
          value={this.state.revealToken ? this.state.accessToken : 'Stored on server. Click Reveal Token to inspect it.'}
          fullWidth
          multiLine
          rows={2}
          style={style.field}
        />
        <RaisedButton
          label={this.state.revealToken ? 'Hide Token' : 'Reveal Token'}
          secondary
          onClick={this.toggleToken}
          style={style.button}
        />
      </div>
    )
  }

  render() {
    return (
      <div style={style.layout}>
        <Paper style={style.paper} zDepth={4}>
          <div style={style.title}>Shopify Callback</div>
          <div style={style.body}>
            {this.state.loading
              ? 'Finishing the Shopify OAuth exchange and storing the access token.'
              : this.state.success
              ? 'The Shopify access token was exchanged successfully and saved for the server-side sync and fulfillment endpoints.'
              : 'The Shopify OAuth callback could not be completed.'}
          </div>

          {this.state.success ? (
            <div style={style.success}>
              <div><strong>Shop:</strong> {this.state.shop}</div>
              <div><strong>Scopes:</strong> {this.state.scope || 'Not reported by Shopify'}</div>
              <div><strong>Installed:</strong> {this.state.installedAt || 'Unknown'}</div>
              {this.renderToken()}
            </div>
          ) : null}

          {this.state.error ? <div style={style.error}>{this.state.error}</div> : null}

          {!this.state.loading ? (
            <RaisedButton
              label="Back to Shopify Setup"
              primary
              onClick={this.restart}
              style={style.button}
            />
          ) : null}
        </Paper>
      </div>
    )
  }
}

export default ShopifyCallback
